export default __webpack_public_path__ + "static/media/photo_msn-dinero.ba2dc73a.jpg";